import { render, staticRenderFns } from "./LocationServiceIcon.vue?vue&type=template&id=9625bfb2&"
import script from "./LocationServiceIcon.vue?vue&type=script&lang=js&"
export * from "./LocationServiceIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports